import type { Customer } from './api';

/**
 * Demo roster for the Studio console. The first "Moxo" target carries the REAL
 * Moxo brand (near-black band, cyan accent, GT America, the actual logo) and is
 * the fallback house brand. The others are fictional customer takeovers — their
 * own colors, and a text wordmark of their name (no logo, since we don't have
 * real assets for fictional companies). A real customer would carry their own
 * brandingConfig + logo asset.
 */
export const CUSTOMERS: Customer[] = [
  {
    id: 'moxo',
    name: 'Moxo (house brand)',
    industry: 'Workflow automation',
    brand: {
      companyName: 'Moxo',
      primaryColor: '#22201E', // real Moxo near-black chrome
      accentColor: '#44BEE8', // real Moxo cyan accent
      fontFamily: 'GT America', // real Moxo brand font (embedded from contenthub)
      wordmark: 'Moxo',
      logoAssetRef: 'moxo-logo-white', // the real logo, reversed for the dark band
    },
    facts: [
      'Launch branded client onboarding flows in minutes, not weeks',
      'One secure portal for documents, approvals, e-sign, and payments',
      'Clients complete tasks by magic link — no account or app install',
    ],
  },
  {
    id: 'northwind',
    name: 'Northwind Capital',
    industry: 'Financial services',
    brand: {
      companyName: 'Northwind Capital',
      primaryColor: '#16324F',
      accentColor: '#E0A82E',
      fontFamily: 'Inter',
      wordmark: 'Northwind',
    },
    facts: [
      'Reduced average time-to-close from 27 to 11 days',
      '68% less back-office data entry per client onboarding',
      'Onboarded 1,200 institutional clients through a single branded portal',
    ],
  },
  {
    id: 'meridian',
    name: 'Meridian Health',
    industry: 'Healthcare',
    brand: {
      companyName: 'Meridian Health',
      primaryColor: '#0E7C7B',
      accentColor: '#57B3A6',
      fontFamily: 'Inter',
      wordmark: 'Meridian',
    },
    facts: [
      'Cut new-patient intake from 9 days to 2',
      'HIPAA-compliant document exchange across 14 clinics',
      '40% less paperwork per patient onboarding',
    ],
  },
  {
    id: 'acme-bank',
    name: 'Acme Bank',
    industry: 'Banking',
    brand: {
      companyName: 'Acme Bank',
      primaryColor: '#7A1E55',
      accentColor: '#DB6FAA',
      fontFamily: 'Inter',
      wordmark: 'Acme',
    },
    facts: [
      'Opened 3,400 accounts in the first quarter on Moxo',
      'Loan approvals move 3× faster with automated document collection',
      'Zero-branch account opening with a full compliance audit trail',
    ],
  },
];
